import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { DashboardStafferFunnelStats, HttpResponse } from "@/types";

export function useGetDashboardStafferFunnelStats() {
  return useQuery({
    queryKey: ["dashboard-staffer-funnel-stats"],
    queryFn: async () => {
      const res = await guacHttpClient.get<
        DashboardStafferFunnelStats[],
        HttpResponse<DashboardStafferFunnelStats[]>
      >("dashboard/staffer-funnel-stats");
      return res.data;
    },
  });
}
